import * as Sentry from "@sentry/electron/renderer";

// Side-effect import: registra extensions de Pixi (Canvas, Graphics, etc).

// Sin esto, Rolldown tree-shakea los init modules en prod y se cae con

// "Cannot read properties of undefined (reading 'CanvasSystem')".

import "pixi.js/browser";

// Side-effect import: instala los polyfills de Pixi que NO usan eval (WebGL +

// WebGPU) y desactiva el check de unsafe-eval. El CSP de prod (app.eriol.io) NO

// incluye 'unsafe-eval' (vite.config lo mete solo en dev, por seguridad), y Pixi

// lo requiere para generar shaders → sin esto App.init() tira "Current

// environment does not allow unsafe-eval" y no se crea el canvas.

import "pixi.js/unsafe-eval";

// Pixi 8.20.1 corrige los offsets WGSL/STD140, pero el polyfill sigue
// escribiendo uniforms i32 como float. Conservar el parche de enteros.

import "./lib/pixiUnsafeEvalUboFix";

import ReactDOM from "react-dom/client";

import "@eriol-io/design-system/styles";

import "./main.css";

import Root from "./Root";

import "react-tooltip/dist/react-tooltip.css";

import "./styles/window-controls.css";

import {
  registerServiceWorker,
  setupChunkErrorRecovery,
} from "./Utils/serviceWorker";

import { initAnalytics } from "./infrastructure/Services/AnalyticsService";

import { initConsoleBuffer } from "./lib/consoleBuffer";

import { lazy, Suspense } from "react";

// Capture renderer console output + uncaught errors into a bounded ring buffer

// so the native "Reportar un problema" flow can attach "the browser logs".

// Runs before the app mounts to catch early startup logs.

initConsoleBuffer();

// Lazy: solo carga la página de composición (y el grafo de entities: Radio, Streaming, etc.)

// en modo broadcast — NO en el control window. Preserva el arranque liviano original.

const BroadcastComposition = lazy(
  () => import("./broadcast/BroadcastComposition"),
);

// ?mode=broadcast → el OSR window monta SOLO la composición (engine) a 4K. El resto

// de la app (studio = control) monta <Root />.

const isBroadcastMode =
  new URLSearchParams(window.location.search).get("mode") === "broadcast";

// Sentry (Cloud, org eriolio / US region). The renderer inherits most of its config

// (environment/release) from the main process via the injected preload; we

// only pass the DSN here. Guarded so it stays fully INERT when

// VITE_SENTRY_DSN is unset. Sentry's global handlers auto-capture uncaught

// errors and unhandled rejections in both the control and OSR windows.

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // Session Replay SOLO en el control window: el OSR (?mode=broadcast) es un

    // canvas headless 4K sin DOM útil que grabar y duplicaría sesiones. Mismo

    // enmascarado que los frontends web (texto/inputs/media ocultos).

    integrations: isBroadcastMode
      ? []
      : [
          Sentry.replayIntegration({
            maskAllText: true,

            maskAllInputs: true,

            blockAllMedia: true,
          }),
        ],

    replaysSessionSampleRate: isBroadcastMode ? 0 : 1.0,

    replaysOnErrorSampleRate: isBroadcastMode ? 0 : 1.0,
  });
}

if (!isBroadcastMode) {
  // Service Worker + GA4 solo en la app de control (no en el OSR de broadcast).

  // Dentro de Electron, registerServiceWorker NO registra: desregistra los SW

  // existentes (el shell carga app.eriol.io remoto y los shells ya instalados

  // tienen un SW controlando el renderer).

  registerServiceWorker().catch(console.error);

  // Red de seguridad: si un shell viejo pide un chunk con hash muerto tras un

  // deploy, auto-recargamos UNA vez (gated por version.json) para traer el

  // bundle fresco. Solo prod y nunca en el OSR (no se corta un vivo).

  if (import.meta.env.PROD) setupChunkErrorRecovery();

  // GA4 telemetry — idempotent, no-ops if VITE_GA_MEASUREMENT_ID is unset.

  initAnalytics();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  isBroadcastMode ? (
    <Suspense fallback={null}>
      <BroadcastComposition />
    </Suspense>
  ) : (
    <Root />
  ),
);
